// extracted by mini-css-extract-plugin
export default {"grid":"TodaySection_grid__enuml","grid3":"TodaySection_grid3__+OxIZ"};